{
    "coordinates": [
        51.4382932977928,
        -116.47236584137684
    ],
    "tooltip": "Burgess",
    "title": "Burgess Shale (Walcott Quarry)",
    "country": "Canada",
    "period": "Cambrian"
}
